import { Capacitor } from '@capacitor/core';
import { NativeCalls } from 'src/app/plugins/native-runtime.plugins';
import { Injectable } from '@angular/core';
import { User } from 'src/app/Models/Classes/User/user';
import { RequestService } from '../request/request.service';
import Swal2 from 'sweetalert2';
import { SocialInteractionNotificationService } from '../notifications/social-interaction-notification.service';

@Injectable({
	providedIn: 'root'
})
export class AuthService {
	constructor(
		private request: RequestService,
		private socialNotifications: SocialInteractionNotificationService,
		
	) { }

	public register(user: User): Promise<any> {
		return new Promise((resolve, reject) => {
			this.request.createRequestPost('register', user).then((data) => {
				resolve(data);
			}).catch((error) => {
				// The page owns the presentation lifecycle so it can dismiss its
				// loader before displaying the API's actual validation error.
				reject(error)
			})
		});
	}


	public login(user: User): Promise<any> {
		return new Promise((resolve, reject) => {
			this.request.createRequestPost('login', user).then((data) => {
			
				resolve(data);
			}).catch((error) => {
			
					Swal2.fire({
						title: 'Error de inicio de sesión',
						text: 'The email and/or password do not match',
						icon: 'error',
						confirmButtonText: 'Understood',
						color: '#ffffff',
						background: '#010f4e',
						position: 'top-end',
						timerProgressBar: true,
						toast: true,
					  }).then(() => {
						console.log("Alert displayed successfully.");
					  }).catch((error) => {
						console.error("Error displaying alert:", error);
					  });
					console.error(error);
				
				reject(error);
			});
		});
	}

	public logout(): Promise<any> {
        window.dispatchEvent(new Event('laniakea:call-session-ended'));
		return new Promise((resolve, reject) => {
			Promise.resolve().then(() => {
				if (Capacitor.getPlatform() === 'ios' && Capacitor.isPluginAvailable('NativeCalls')) {
					return NativeCalls.unregister().catch(console.warn);
				}
				return undefined;
			}).then(() => this.request.createRequestPost('logout', { 'key': 'value' })).then((data) => {
				this.socialNotifications.notifyLocal(
					'Sesión cerrada',
					'Tu sesión de Laniakea se cerró correctamente.',
					{ event_type: 'logout_success' },
				);
				resolve(data);
			}).catch((error) => {
				reject(error);
			});
		});
	}

	public getVersion() {
		return new Promise((resolve, reject) => {
			this.request.createRequestGet('getVersion').then((data) => {
				resolve(data);
			}).catch((error) => {
				reject(error);
			});
		});
	}
	public ForgotPassword(email: any): Promise<any> {
		return new Promise((resolve, reject) => {
			this.request.createRequestPost('send-email', email).then((data) => {
			
				resolve(data);
			}).catch((error) => {
				reject(error);
			});
		});
	}
}
